import { createChildListPrintContainer } from 'factories/ChildListPrint'
import actions from 'actions/orders/orderItems'
import Component from 'components/Orders/Print/Items'

export default createChildListPrintContainer({
  actions,
  extraStateToProps: (state, props) => ({ settingsType: props.settingsType ?? 'order' }),
})(Component)
